import { Card, CardContent, Icon, Typography, Grid, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// recharts doc -> custom tooltip
const AnimalDataChartTooltip = ({ active, payload, label }: any) => {
  const { t } = useTranslation();

  if (!active) {
    return null;
  }

  return (
    <Card variant="elevation" elevation={1}>
      <CardContent style={{ paddingBottom: 10 }}>
        <Grid container direction="row">
          <Icon fontSize="small" color="primary">
            {'today'}
          </Icon>

          <Typography color="primary" gutterBottom>
            {t('f-dashboard-chart-ox', { label })}
          </Typography>
        </Grid>

        <Divider />

        <Grid container direction="column">
          {payload.map((row: any) => (
            <Grid item key={row.name}>
              <Typography variant="body2" component="div" style={{ color: row.fill }}>
                {`${row.name}: ${row.value}`}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AnimalDataChartTooltip;
